import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';
import { IFlowEventData } from 'types/analytics';

export const TEXT_KEYS = {
    LANDING_TITLE: 'landing__code-first-title-text',
    LANDING_DESCRIPTION: 'login__login-title-text'
};

export const INITIAL_LANDING_DATA: Omit<IFlowEventData, 'flowType'> = {
    flowStep: 'main',
    action: 'main landing page',
    category: CATEGORY.DISPLAY
};

export const ON_SUBMIT_CODE_DATA = {
    ...INITIAL_LANDING_DATA,
    action: 'submit my code',
    category: CATEGORY.ACTION
};
